import { IMessageProps } from '@/entities/Message'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IMessageState {
  response: IResponseProps<IMessageProps>
  current: IMessageProps | null
  filter: string
}

export const state = (): IMessageState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all'
})

export default state
